import React, { useCallback } from 'react';
import { tap } from 'rxjs/operators';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { CROP_WORK_VIEW } from '../../../router/routes';
import FieldTypes from '../../../enums/field-types';
import Paginate from '../../../interfaces/paginate';
import Work from '../../../interfaces/work';
import Field from '../../../interfaces/field';
import { useService } from '../../../services/services';
import { route } from '../../../services/utils';
import Table from '../../../components/common/table/table';
import css from '../index.module.css';

export default function WorksList() {
  const { t } = useTranslation();
  const tp = useCallback(
    (key: string) => t('pages.dashboard.works.'.concat(key)),
    [t]
  );
  const { workService } = useService();
  const { farmId, season } = useSelector((state: RootState) => ({
    farmId: state.global?.farm?.id,
    season: state.global?.season,
  }));
  const request = useCallback(
    () =>
      workService
        .index(farmId, season, {
          page: 1,
          sort: 'date',
          desc: true,
          per_page: 5,
          done: true,
        })
        .pipe(
          tap((p: Paginate<Work>) => {
            p.data.forEach((work: Work) => {
              work.treated_area = work.fields.reduce(
                (sum: number, field: Field) => {
                  return Number(sum) + Number(field.pivot.treated_area);
                },
                0
              );
              work.treated_area = parseFloat(work.treated_area.toFixed(2));
            });
            return p;
          })
        ),
    [workService, farmId, season]
  );

  return (
    <div className={css['container']}>
      <Table<Work>
        toolbar={null}
        request={request}
        keyAccessor="id"
        paginate={false}
        columns={[
          {
            accessor: 'date',
            header: tp('date'),
            className: css['strong'],
          },
          {
            accessor: 'work.value',
            header: tp('work'),
            className: css['strong'],
          },
          {
            accessor: 'field_name_agg',
            dataType: FieldTypes.JSON_AGG,
            header: tp('field_name'),
          },
          {
            accessor: 'treated_area',
            header: tp('treated_area'),
          },
        ]}
        viewRoute={route(CROP_WORK_VIEW, {
          farmId: farmId,
          season: season,
        })}
        viewRecordAbility={{ entity_type: 'work' }}
      />
    </div>
  );
}
